<template>
  <div class="v-atlas-raster-geodata-query-panel">



    <template v-if="valueQueryError">
      <p class="error">
        Fehler: {{ valueQueryError }}
      </p>
    </template>

    <template v-else-if="result">
      <TabsGroup class="x-auto-expand">
        <!--#region Details tab-->
        <Tab label="Details" tab-key="details">
          <dl class="value-details">
            <dt>Wert</dt>
            <dd>
              <template v-if="result.value !== null">
                {{ result.value }}
              </template>
              <template v-else>
                Keine Daten
              </template>
            </dd>
            <dt>Jahr</dt>
            <dd>{{ result.timestamp }}</dd>
            <dt>Koordinaten</dt>
            <dd>{{ result.lat.toFixed(3) }}, {{ result.lon.toFixed(3) }}</dd>
          </dl>
        </Tab>
        <!--#endregion Details tab-->


        <!--#region Time series tab-->
        <Tab label="Zeitreihe" tab-key="timeseries" class="tab-time-series">
          <RasterGeodataTimeSeriesPanel :data="result" @item-click="onItemClick"
            :raster-style="props.mapModule.reactiveData.requestSettings.colorScheme" />
        </Tab>
        <!--#endregion Time series tab-->
      </TabsGroup>
    </template>

    <template v-else>
      <p>Keine Daten verfügbar.</p>
    </template>

    <LoadingIndicatorOverlay v-if="isLoadingDelayed" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { LoadingIndicatorOverlay, ViewStackController, useDelayedBoolean, Tab, TabsGroup, useSmartFetch } from "gertrud";
import { RasterGeodataMapModule } from "./RasterGeodataMapModule";
import { RasterGeodataQueryResponse, RasterGeodataValueQuerySettings } from "atlas-shared";

import RasterGeodataTimeSeriesPanel from "./rasterGeodataTimeSeriesPanel.vue";

const props = defineProps<{
  mapModule: RasterGeodataMapModule
  viewStackController: ViewStackController
  coordinates: { lat: number; lon: number }
}>()


function onItemClick(item: any) {
  props.mapModule.setTimestamp(item.item.timestamp);
}

const queryUrl = computed(() => {
  const timestamp = props.mapModule.reactiveData.requestSettings.timestamp;
  if (!timestamp) return ""

  const settings: RasterGeodataValueQuerySettings = { lat: props.coordinates.lat, lon: props.coordinates.lon, timestamp, includeTimeSeries: true };
  const settingsParam = encodeURIComponent(JSON.stringify(settings));
  return `${props.mapModule.serviceBaseUrl}value?settings=${settingsParam}`;
})

const { data: result, error: valueQueryError, isLoading: isLoadingValue } = useSmartFetch<RasterGeodataQueryResponse>(queryUrl)

const isLoadingDelayed = useDelayedBoolean(isLoadingValue, 250, 0);


</script>
